
import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ExternalMovements } from 'app/models/loyalty-movement.model';
import { MessageService } from 'primeng/api';
import { LoyaltyMovementService } from 'app/services/loyalty/loyalty-movement.service';
import * as XLSX from 'xlsx';
import { from } from 'rxjs/observable/from';
import { concatMap, tap, catchError } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';
import { TranslateService } from '@ngx-translate/core';

type AOA = ExternalMovements[];

@Component({
  selector: 'app-form-import-movement-loyalty',
  templateUrl: './form-import-movement-loyalty.component.html',
  styleUrls: ['./form-import-movement-loyalty.component.css']
})
export class FormImportMovementLoyaltyComponent implements OnInit {

  form: FormGroup;
  public invalidSubmit: boolean;
  public viewImportDialog: boolean;
  private movementFile: File = null;
  private movementData: AOA;

  stringaEsito = '';
  imported: any;
  errori: any;
  errorCount: any;

  constructor(
    private fb: FormBuilder,
    private notifyService: MessageService,
    public translate: TranslateService,
    public movementService: LoyaltyMovementService
  ) { }

  get details(): FormArray {
    return this.form.get('details') as FormArray;
  }

  ngOnInit() { }

  onMovementFileUpload(event) {
    if (event.files.length !== 1) {
      throw new Error('Cannot use multiple files');
    }
    this.movementFile = event.files[0];
  }

  runImportMovement(fileUploadRef) {
    this.viewImportDialog = false;
  
    const reader: FileReader = new FileReader();
    reader.onload = (e: any) => {
  
      const bstr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(bstr, {type: 'binary', cellDates: true});
      const wsname: string = wb.SheetNames[0];
      const ws: XLSX.WorkSheet = wb.Sheets[wsname];
  
      this.movementData = <AOA>(XLSX.utils.sheet_to_json(ws, {blankrows: true, defval: null}));
  
      this.imported = [];
      this.errori = [];
      this.errorCount = 0;
  
      // Creo array di observables protetti dall'errore
      const movementsObs = this.movementData.map((row, index) => {
        // Formatto data
        const data = new Date(row.xact_date);
        const anno = data.getFullYear();
        const mese = data.getMonth() + 1;
        const giorno = data.getDate();
        row.xact_date = `${anno}-${mese < 10 ? '0' : ''}${mese}-${giorno < 10 ? '0' : ''}${giorno}`;
  
        // Formatto ora
        const dateTime = new Date(row.xact_time);
        const hours = dateTime.getHours();
        const minutes = dateTime.getMinutes();
        const seconds = dateTime.getSeconds();
        row.xact_time = `${hours < 10 ? '0' : ''}${hours}:${minutes < 10 ? '0' : ''}${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
  
        // Observable con gestione errori interna
        return this.movementService.insertMovement(row).pipe(
          tap(movement => {
            if (movement && movement.id) {
              this.imported.push(movement.id);
            }
          }),
          catchError(error => {
            // Registro errore ma NON rilancio: così la sequenza continua
            this.errori.push(index + 1); // o row se preferisci
            this.errorCount++;
            return of(null);
          })
        );
      });
  
      // Eseguo le chiamate una ad una, concatenandole
      from(movementsObs).pipe(
        concatMap(obs => obs)
      ).subscribe({
        complete: () => {
          this.notifyResults(this.imported, this.errorCount, this.errori, movementsObs.length);
        }
      });
    };
  
    if (this.movementFile != null) {
      reader.readAsBinaryString(this.movementFile);
    }
  
    this.movementFile = null;
    fileUploadRef.clear();
  }
  
  
  notifyResults(imported: any[], errorCount: number, errori: any[], movementsObsLeng: number ) {
    if (imported.length > 0) {
      this.notifyService.add({severity: 'success', detail: 'Process has successfully imported ' + imported.length + ' movements.'});
    }
    if (errorCount === movementsObsLeng) {
      this.stringaEsito = this.translate.instant('movement.errorImportMovementFile');
    } else if (errorCount === 0) {
      this.stringaEsito = this.translate.instant('movement.okImportMovementFile');
    } else {
      this.stringaEsito = this.translate.instant('movement.errorImportMovementFilePart1') + errori.join(', ') + this.translate.instant('movement.errorImportMovementFilePart1');
      this.notifyService.add({severity: 'error', detail: this.stringaEsito});
    }
  }

}


// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-movement/form-import-movement-loyalty/form-import-movement-loyalty.component.ts